import styled from 'styled-components';
import PropTypes from 'prop-types';
import {
  Spacings,
  Fonts,
  BorderColors,
  TextColors
} from '../../../../../styleConstants';
import { getTime, getIsLive } from '../scheduleHelper';
import ScheduleCard from '../ScheduleCard';

const Wrapper = styled.div`
  display: grid;
  grid-template-rows: 1fr;
  border-bottom: ${Spacings.SPACING_2} solid
    ${({ $hasLiveClass }) =>
      $hasLiveClass ? BorderColors.RED : BorderColors.GREY};
  grid-template-columns: 65px 1fr;
  grid-column-gap: ${Spacings.SPACING_2B};
  padding: ${Spacings.SPACING_6B} ${Spacings.SPACING_0B};
`;

const Time = styled.span`
  font-weight: ${Fonts.REGULAR};
  font-size: ${Fonts.H6};
  line-height: ${Fonts.HEADER_LINE_HEIGHT};
  color: ${({ $hasLiveClass }) => ($hasLiveClass ? TextColors.RED : '#7b8ab5')};
`;

const ScheduleRowMobile = ({ data }) => {
  const hasLiveClass = getIsLive(data);
  return (
    <Wrapper $hasLiveClass={hasLiveClass}>
      <Time $hasLiveClass={hasLiveClass}>
        {`${getTime(data.live_at, 'hrs')} : ${getTime(data.live_at)}`}
      </Time>
      <ScheduleCard data={data} />
    </Wrapper>
  );
};

ScheduleRowMobile.propTypes = {
  data: PropTypes.objectOf(PropTypes.any).isRequired
};

export default ScheduleRowMobile;
